export class OpportunityBySeasonRequest implements IOpportunityBySeasonRequest {
  companyId!: string;
  seasonNumber!: number;
  seasonYear!: number;

  constructor(data?: IOpportunityBySeasonRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.companyId = Data["companyId"];
      this.seasonNumber = Data["seasonNumber"];
      this.seasonYear = Data["seasonYear"];
    }
  }

  static fromJS(data: any): OpportunityBySeasonRequest {
    data = typeof data === 'object' ? data : {};
    let result = new OpportunityBySeasonRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["companyId"] = this.companyId;
    data["seasonNumber"] = this.seasonNumber;
    data["seasonYear"] = this.seasonYear;
    return data;
  }
}

export interface IOpportunityBySeasonRequest {
  companyId: string;
  seasonNumber: number;
  seasonYear: number;
}